import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import { NgxFileDropModule } from 'ngx-file-drop';
import { BlockItemComponent } from './html-block/block-item/block-item.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { FormInputComponent } from './form-input/form-input.component';
import { HtmlBlockComponent } from './html-block/html-block.component';
import { ModalComponent } from './modal/modal.component';
import { PubDatePickerComponent } from './pub-date-picker/pub-date-picker.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { SwitchComponent } from './switch/switch.component';
import { SuccessModalComponent } from './success-modal/success-modal.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { NotificationCardsComponent } from './notification-cards/notification-cards.component';
import { KeepHtmlPipe } from './pipes/keep-html.pipe';
import { MailToComponent } from './mail-to/mail-to.component';
import { FooterComponent } from './footer/footer.component';
import { VersionUpdateBannerComponent } from './version-update-banner/version-update-banner.component';
import { StripeFormComponent } from './payment-form/stripe-form/stripe-form.component';
import { StripeStoredCardsComponent } from './payment-form/stripe-stored-cards/stripe-stored-cards.component';
import { FileDropComponent } from './file-drop/file-drop.component';
import { CartModalComponent } from './cart-modal/cart-modal.component';
import { UpsellModalComponent } from './upsell-modal/upsell-modal.component';
import { DiscountTrackerComponent } from './discounts/discount-tracker/discount-tracker.component';
import { DiscountBlockComponent } from './discounts/discount-block/discount-block.component';
import { MembershipModalComponent } from './membership-modal/membership-modal.component';
import { CongratsModalComponent } from './congrats-modal/congrats-modal.component';
import { CancelPlanModalComponent } from './cancel-plan-modal/cancel-plan.component';
import { CardExclusiveComponent } from './exclusives/card-exclusive/card-exclusive.component';
import { UpdateCardComponent } from './update-card/update-card.component';
import { ListCardsModalComponent } from './list-cards-modal/list-cards-modal.component';
import { ListStripeCardsModalComponent } from './list-stripe-cards-modal/list-stripe-cards-modal.component';
import { AddCardComponent } from './add-card/add-card.component';
import { InputFormComponent } from './input-form/input-form.component';
import { CheckboxFormComponent } from './checkbox-form/checkbox-form.component';
import { TextareaFormComponent } from './textarea-form/textarea-form.component';
import { FilterComponent } from './promo-wizard/filter/filter.component';
import { AddBookComponent } from '../author-dashboard/add-book/add-book.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { PromoWizardEditBookComponent } from './promo-wizard/edit-book/edit-book.component';
import { TooltipCardComponent } from './tooltip-card/tooltip-card.component';
import { SiteAdvertDetailsModalComponent } from './promo-wizard/site-advert-details-modal/site-advert-details-modal.component';
import { ProgressStepperComponent } from './progress-stepper/progress-stepper.component';
import { SharedEditBookComponent } from './edit-book/edit-book.component';
import { BookSearchComponent } from './book-search/book-search.component';
import { NewBookComponent } from './new-book/new-book.component';
import { BookCoverComponent } from './book-cover/book-cover.component';
import { CartFeatureComponent } from './cart-feature/cart-feature.component';
import { CartEventComponent } from './cart-event/cart-event.component';
import { CartPromoStackComponent } from './cart-promo-stack/cart-promo-stack.component';
import { CartSubscriptionComponent } from './cart-subscription/cart-subscription.component';
import { CartFeatureNuggetComponent } from './cart-feature-nugget/cart-feature-nugget.component';
import { CartEventNuggetComponent } from './cart-event-nugget/cart-event-nugget.component';
import { CartPromoStackNuggetComponent } from './cart-promo-stack-nugget/cart-promo-stack-nugget.component';
import { CartSubscriptionNuggetComponent } from './cart-subscription-nugget/cart-subscription-nugget.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { PillBarComponent } from './pill-bar/pill-bar.component';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import { MemberBadgeComponent } from './member-badge/member-badge.component';
import { MemberMenuComponent } from './member-menu/member-menu.component';
import { InterstitialModalComponent } from './interstitial-modal/interstitial-modal.component';
import { PromoStacksModalComponent } from './promo-stacks-modal/promo-stacks-modal.component';
import { PromoStacksTopBarComponent } from './promo-stacks-top-bar/promo-stacks-top-bar.component';
import { MemberBenefitComponent } from './member-benefit/member-benefit.component';
import { PromoStackFiltersComponent } from './promo-stacks-filters/promo-stacks-filters.component';
import { CardResourceComponent } from './card-resource/card-resource.component';
import { GuestSidebarComponent } from './guest-sidebar/guest-sidebar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SignupLoginComponent } from './signup-login/signup-login.component';
import { LaunchNewBookWidgetComponent } from './launch-new-book-widget/launch-new-book-widget.component';
import { GrowYourEmailListWidgetComponent } from './grow-your-email-list-widget/grow-your-email-list-widget.component';
import { PromoteYourBookWidgetComponent } from './promote-your-book-widget/promote-your-book-widget.component';
import { WelcomeHeaderWidgetComponent } from './welcome-header-widget/welcome-header-widget.component';
import { SliderAddsWidgetComponent } from './slider-adds-widget/slider-adds-widget.component';
import { DiscountBlockWidgetComponent } from './discount-block-widget/discount-block-widget.component';
import { DownloadCalloutComponent } from './download-callout/download-callout.component';
import { AuthorProfileCtaComponent } from './author-profile-cta/author-profile-cta.component';
import { ConfirmModalV2Component } from './confirm-modal-v2/confirm-modal-v2.component';
import { UniversalBookFetchComponent } from './universal-book-fetch/universal-book-fetch.component';
import { PromoStackDatePickerComponent } from './promo-stack-date-picker/promo-stack-date-picker.component';

import { SiteAdvertAuthorComponent } from './site-advert-author/site-advert-author.component';
import { PromotionsWidgetComponent } from './promotions-widget/promotions-widget.component';

import { DiscountMeterComponent } from './discount-meter/discount-meter.component';

import { ClickOutsideDirective } from '../core/directives/click-outside.directive';

import { PubDatePipe } from '../core/pipes/pubDate.pipe';
import { TabsAccountMenuComponent } from './tabs-account-menu/tabs-account-menu.component';
import { SimpleSwitchComponent } from './simple-switch/simple-switch.component';
import { BookCardSelectableComponent } from './book-card-selectable/book-card-selectable.component';
import { PromoStacksBannerComponent } from './promo-stacks-banner/promo-stacks-banner.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { DrawerComponent } from './drawer/drawer.component';
import { BookShelfSearchComponent } from './book-shelf-search/book-shelf-search.component';
import { RecurringPromotionComponent } from './recurring-promotion/recurring-promotion.component';
import { NewErrorModalComponent } from './new-error-modal/new-error-modal.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { RecurringFeatureListComponent } from './recurring-feature-list/recurring-feature-list.component';
import { StepperComponent } from './stepper/stepper.component';
import { SiteCardComponent } from './site-card/site-card.component';
import { SchemaFormBuilderComponent } from './schema-form-builder/schema-form-builder.component';
import { InputTextComponent } from './input-text/input-text.component';
import { EventTicketComponent } from './event-ticket/event-ticket.component';
import { EventDetailsCardComponent } from './event-details-card/event-details-card.component';
import { InputNumberComponent } from './input-number/input-number.component';
import { InputSelectComponent } from './input-select/input-select.component';
import { InputTextareaComponent } from './input-textarea/input-textarea.component';
import { InputSwitchComponent } from './input-switch/input-switch.component';
import { InputRadioComponent } from './input-radio/input-radio.component';
import { LeadMagnetFormComponent } from './lead-magnet-form/lead-magnet-form.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		NgSelectModule,
		ReactiveFormsModule,
		RouterModule,
		NgxFileDropModule,
		FontAwesomeModule,
	],
	declarations: [
		BlockItemComponent,
		ConfirmModalComponent,
		ConfirmModalV2Component,
		SwitchComponent,
		ErrorModalComponent,
		FormInputComponent,
		HtmlBlockComponent,
		ModalComponent,
		PubDatePickerComponent,
		SuccessModalComponent,
		TopBarComponent,
		NotificationCardsComponent,
		KeepHtmlPipe,
		MailToComponent,
		FooterComponent,
		VersionUpdateBannerComponent,
		FileDropComponent,
		CartModalComponent,
		UpsellModalComponent,
		DiscountTrackerComponent,
		DiscountBlockComponent,
		MembershipModalComponent,
		CongratsModalComponent,
		CardExclusiveComponent,
		CancelPlanModalComponent,
		UpdateCardComponent,
		AddCardComponent,
		ListCardsModalComponent,
		ListStripeCardsModalComponent,
		InputFormComponent,
		CheckboxFormComponent,
		TextareaFormComponent,
		FilterComponent,
		PromoWizardEditBookComponent,
		AddBookComponent,
		DatepickerComponent,
		TooltipCardComponent,
		SiteAdvertDetailsModalComponent,
		ProgressStepperComponent,
		SharedEditBookComponent,
		BookSearchComponent,
		NewBookComponent,
		BookCoverComponent,
		CartFeatureComponent,
		CartEventComponent,
		CartSubscriptionComponent,
		CartPromoStackComponent,
		CartFeatureNuggetComponent,
		CartEventNuggetComponent,
		CartSubscriptionNuggetComponent,
		CartPromoStackNuggetComponent,
		ProductCardComponent,
		PillBarComponent,
		ToggleSwitchComponent,
		MemberBadgeComponent,
		MemberMenuComponent,
		InterstitialModalComponent,
		PromoStacksModalComponent,
		PromoStacksTopBarComponent,
		PromoStackFiltersComponent,
		MemberBenefitComponent,
		StripeStoredCardsComponent,
		StripeFormComponent,
		CardResourceComponent,
		ClickOutsideDirective,
		GuestSidebarComponent,
		SiteAdvertAuthorComponent,
		PromotionsWidgetComponent,
		DiscountMeterComponent,
		PubDatePipe,
		SidebarComponent,
		SignupLoginComponent,
		LaunchNewBookWidgetComponent,
		GrowYourEmailListWidgetComponent,
		PromoteYourBookWidgetComponent,
		WelcomeHeaderWidgetComponent,
		SliderAddsWidgetComponent,
		DiscountBlockWidgetComponent,
		DownloadCalloutComponent,
		AuthorProfileCtaComponent,
		TabsAccountMenuComponent,
		SimpleSwitchComponent,
		BookCardSelectableComponent,
		PromoStacksBannerComponent,
		ContactFormComponent,
		DrawerComponent,
		BookShelfSearchComponent,
		RecurringPromotionComponent,
		NewErrorModalComponent,
		SpinnerComponent,
		RecurringFeatureListComponent,
		StepperComponent,
		SiteCardComponent,
		SchemaFormBuilderComponent,
		InputTextComponent,
		InputNumberComponent,
		InputSelectComponent,
		InputTextareaComponent,
		InputSwitchComponent,
		InputRadioComponent,
		LeadMagnetFormComponent,
		EventTicketComponent,
		EventDetailsCardComponent,
		UniversalBookFetchComponent,
		PromoStackDatePickerComponent,
	],
	exports: [
		CommonModule,
		FormsModule,
		RouterModule,
		ReactiveFormsModule,
		NgxFileDropModule,
		ConfirmModalComponent,
		ConfirmModalV2Component,
		ErrorModalComponent,
		FormInputComponent,
		HtmlBlockComponent,
		ModalComponent,
		PubDatePickerComponent,
		SuccessModalComponent,
		TopBarComponent,
		NotificationCardsComponent,
		KeepHtmlPipe,
		MailToComponent,
		FooterComponent,
		VersionUpdateBannerComponent,
		UpsellModalComponent,
		FileDropComponent,
		CartModalComponent,
		DiscountTrackerComponent,
		DiscountBlockComponent,
		MembershipModalComponent,
		CongratsModalComponent,
		CardExclusiveComponent,
		CancelPlanModalComponent,
		UpdateCardComponent,
		AddCardComponent,
		ListCardsModalComponent,
		ListStripeCardsModalComponent,
		InputFormComponent,
		CheckboxFormComponent,
		TextareaFormComponent,
		FilterComponent,
		PromoWizardEditBookComponent,
		AddBookComponent,
		DatepickerComponent,
		TooltipCardComponent,
		SiteAdvertDetailsModalComponent,
		ProgressStepperComponent,
		SharedEditBookComponent,
		BookSearchComponent,
		NewBookComponent,
		BookCoverComponent,
		CartFeatureComponent,
		CartEventComponent,
		CartPromoStackComponent,
		CartSubscriptionComponent,
		CartFeatureNuggetComponent,
		CartEventNuggetComponent,
		CartSubscriptionNuggetComponent,
		CartPromoStackNuggetComponent,
		ProductCardComponent,
		PillBarComponent,
		ToggleSwitchComponent,
		MemberBadgeComponent,
		MemberMenuComponent,
		InterstitialModalComponent,
		PromoStacksModalComponent,
		PromoStacksTopBarComponent,
		PromoStackFiltersComponent,
		MemberBenefitComponent,
		StripeStoredCardsComponent,
		StripeFormComponent,
		CardResourceComponent,
		ClickOutsideDirective,
		GuestSidebarComponent,
		SiteAdvertAuthorComponent,
		PromotionsWidgetComponent,
		DiscountMeterComponent,
		PubDatePipe,
		SidebarComponent,
		SignupLoginComponent,
		LaunchNewBookWidgetComponent,
		GrowYourEmailListWidgetComponent,
		PromoteYourBookWidgetComponent,
		WelcomeHeaderWidgetComponent,
		SliderAddsWidgetComponent,
		DiscountBlockWidgetComponent,
		DownloadCalloutComponent,
		AuthorProfileCtaComponent,
		TabsAccountMenuComponent,
		SimpleSwitchComponent,
		BookCardSelectableComponent,
		PromoStacksBannerComponent,
		ContactFormComponent,
		DrawerComponent,
		BookShelfSearchComponent,
		RecurringPromotionComponent,
		NewErrorModalComponent,
		SpinnerComponent,
		RecurringFeatureListComponent,
		StepperComponent,
		SiteCardComponent,
		FontAwesomeModule,
		SchemaFormBuilderComponent,
		InputTextComponent,
		InputNumberComponent,
		InputSelectComponent,
		InputTextareaComponent,
		InputSwitchComponent,
		InputRadioComponent,
		LeadMagnetFormComponent,
		EventTicketComponent,
		EventDetailsCardComponent,
		UniversalBookFetchComponent,
		PromoStackDatePickerComponent,
	],
})
export class SharedModule {
}
